function fn(sA, saf) {}

fn._r = [2, [[1, A], [2, A, B]]];
fn.displayName = "fn";